// import { Redirect } from "react-router-dom"
import { all, call, fork, put, takeEvery } from "redux-saga/effects"
import { getCustomerCollectioneApi } from "../../services/Api/CustomerCollectionApi";
import { getCustomerAllCollection,getErrors} from "../reducers/CustomerCollectionReducer"



// Watchers
function* customerCollectionSaga() {
	yield takeEvery("customerCollection/getCustomerCollection", getCustomerCollection)
}

// Sagas
function* getCustomerCollection(action) {
// console.log(action.payload);
	try {
		const getCustomerCollectionData = yield call(getCustomerCollectioneApi, action.payload)
		
		if (getCustomerCollectionData.request.status === 200) {
            // console.log(getCustomerCollectionData);
			yield put(getCustomerAllCollection(getCustomerCollectionData))
		} else {
            // console.log(getCustomerCollectionData)
			yield put(getErrors(getCustomerCollectionData))
		}
	} catch (error) {
      
    
		yield put(getErrors(error))
	}
}

export default function* rootSaga() {
	yield all([fork(customerCollectionSaga)])
}
